module.exports = __webpack_public_path__ + "front/img/slogan01.10cb46b1.png";